import Page from "./Components/Page";
import ShareNaughty from "./Components/ShareNaughty";
import ShareNice from "./Components/ShareNice";
import './App.css';
import GlobalStyle from "./Components/Styles/GlobalStyle";
import { BrowserRouter, Routes, Route } from "react-router-dom";

function App() {

  return (
    <BrowserRouter>
      <div className="App">
      <header>
      
      </header>
      <GlobalStyle />
      <div>
        
        <Routes>          
          <Route path='/' element={<Page/>} />
          <Route path='/naughty' element={<ShareNaughty/>} />
          <Route path='/nice' element={<ShareNice/>} />
        </Routes>
      </div>
    </div>
    </BrowserRouter>

  );
}

export default App;
